import React, { useState, useEffect } from "react";
import { Link, useLocation } from 'react-router-dom';
import Header from './components/header';
import Footer from './components/footer';
import { PostDataAPI } from "./services/PostDataAPI";
import SuccessErrorDialog from "./components/successErrorDialog";
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SEOTags from "./common/SEO";

const Contact = () => {
    const [formData, setFormData] = useState({
        fullName: "",
        phone: "",
        email: "",
        injuryType: "",
        briefDescription: "",
    });
    const initialFormValues = {
        fullName: "",
        phone: "",
        email: "",
        injuryType: "",
        briefDescription: "",
    };


    const handleReset = () => {
        setFormData(initialFormValues);
    }
    const [message, setMessage] = useState(null);
    const [type, setType] = useState(null);
    const [submitLoader, setSubmitLoader] = useState(false);
    const [resultDialog, setResultDialog] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const formatPhoneNumber = (value) => {
        const phone = value.replace(/\D/g, "").substring(0, 10);

        const size = phone.length;

        if (size < 4) return phone;
        if (size < 7) return `(${phone.slice(0, 3)}) ${phone.slice(3)}`;

        return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]:
                name === "phone" ? formatPhoneNumber(value) : value,
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));
    };
    const validate = () => {
        const newErrors = {};

        if (!formData.fullName.trim()) {
            newErrors.fullName = "Full name is required.";
        }

        if (!formData.phone.trim()) {
            newErrors.phone = "Contact number is required.";
        } else if (!/^\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/.test(formData.phone)) {
            newErrors.phone = "Enter a valid phone number.";
        }

        if (!formData.email.trim()) {
            newErrors.email = "Email is required.";
        } else if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
        ) {
            newErrors.email = "Enter a valid email.";
        }

        if (!formData.injuryType) {
            newErrors.injuryType = "Please select an injury type.";
        }

        if (!formData.briefDescription.trim()) {
            newErrors.description = "Please enter a brief description.";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validate()) {
            return;
        } else {
            setSubmitLoader(true);
            setErrors({});
            const formValues = { ...formData };

            try {
                setLoading(true);
                const result = await PostDataAPI("confidentailRequest/add", formValues);
                if (result.success) {
                    setMessage("Your request has been received. Thank you for reaching out. We will review your submission and get in touch with you shortly.");
                    setType("success");
                    setSubmitLoader(false);
                    //handleClose();
                    setTimeout(() => {
                        setResultDialog(true);
                        handleReset()
                    }, 100)
                    //showMessage("Success", result.message || "Meeting request submitted successfully.", "success", 3000);
                } else {
                    setSubmitLoader(false);
                    setMessage(result.message || "Failed to submit request.");
                    setType("error");
                    setResultDialog(true);
                }
            } catch (error) {
                setSubmitLoader(false);
                setMessage("Failed to submit request.");
                setType("error");
                setResultDialog(true);
                //if (error.name !== 'AbortError') {
                //showMessage("Failed to submit meeting request.", "error", 3000);
                //}
            } finally {
                setLoading(false);
                setSubmitLoader(false);
                //setRefreshCaptcha((prev) => !prev); // Trigger a refresh
            }
        }
    };

      useEffect(() => {
            SEOTags(
                "Contact Us | Figgers Law",
            );
        }, [])

    return (
        <>
            <Header></Header>
            <div className="contact-hero-band">
                <div className="container">
                    <div
                        className="section-label"
                        style={{ justifyContent: "center" }}
                    >
                        Contact Figgers Law
                    </div>

                    <h1>Request Your Free Case Review</h1>

                    <p>
                        Share a few details and Natlie G. Figgers' team will review your
                        inquiry and contact you about next steps — no upfront fees, no
                        obligation.
                    </p>
                </div>
            </div>

            <div className="contact-page">
                <div className="container">
                    <div className="contact-grid">
                        <div className="contact-form-wrap">
                            <div className="section-label">Contact</div>

                            <h2>Request Your Confidential Case Review</h2>

                            <p>
                                Share a few details and the Figgers Law team will review your
                                inquiry and contact you regarding next steps.
                            </p>

                            <form
                                style={{ marginTop: "28px" }}
                                onSubmit={handleSubmit}
                            >
                                <div className="form-row">
                                    <div className="form-group">
                                        <label>Full Name</label>
                                        <input
                                            type="text"
                                            name="fullName"
                                            placeholder="Your full name"
                                            value={formData.fullName}
                                            onChange={handleChange}
                                        />
                                        {errors.fullName && (
                                            <small className="error">{errors.fullName}</small>
                                        )}
                                    </div>

                                    <div className="form-group">
                                        <label>Phone Number</label>
                                        <input
                                            type="tel"
                                            name="phone"
                                            placeholder="(XXX) XXX-XXXX"
                                            value={formData.phone}
                                            onChange={handleChange}
                                        />
                                        {errors.phone && (
                                            <small className="error">{errors.phone}</small>
                                        )}
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group">
                                        <label>Email Address</label>
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="your@email.com"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                        {errors.email && (
                                            <small className="error">{errors.email}</small>
                                        )}
                                    </div>
                                    <div className="form-group">
                                        <label>Injury Type</label>

                                        <select name="injuryType"
                                            value={formData.injuryType}
                                            onChange={handleChange}>
                                            <option value="">Select…</option>
                                            <option>Personal Injury</option>
                                            <option>Rear-End Collision</option>
                                            <option>Car Accidents</option>
                                            <option>Pedestrian Accident</option>
                                            <option>Bicycle Accidents</option>
                                            <option>Spinal Injury</option>
                                            <option>Motorcycle Accident</option>
                                            <option>Whiplash Injury</option>
                                            <option>Drunk Driving</option>
                                            <option>Truck Accident</option>
                                            <option>Head-On Collision</option>
                                        </select>

                                        {errors.injuryType && (
                                            <small className="error">{errors.injuryType}</small>
                                        )}
                                    </div>


                                </div>

                                <div className="form-group">
                                    <label>Brief Description</label>

                                    <textarea
                                        rows="3"
                                        name="briefDescription"
                                        placeholder="Briefly describe your situation…"
                                        value={formData.briefDescription}
                                        onChange={handleChange}
                                    />

                                    {errors.description && (
                                        <small className="error">{errors.description}</small>
                                    )}
                                </div>

                                <label
                                    style={{
                                        display: "flex",
                                        alignItems: "flex-start",
                                        gap: "10px",
                                        fontSize: "13px",
                                        color: "var(--muted)",
                                        marginBottom: "16px",
                                        cursor: "pointer",
                                    }}
                                >

                                    <span>
                                        By submitting this form, you agree that Figgers Law may
                                        contact you regarding your inquiry. Submission does not
                                        create an attorney-client relationship.
                                    </span>
                                </label>

                                <button
                                    type="submit"
                                    className="form-submit"
                                >
                                    {submitLoader ? <FontAwesomeIcon
                                        icon={faSpinner}
                                        className="spinner-icon"
                                        spin
                                        style={{ fontSize: "20px", color: "#0f0f0e", marginRight: "10px" }}
                                    /> : ''} Submit Case Review
                                </button>
                            </form>

                            <div className="contact-steps">
                                <h3>What Happens Next</h3>

                                <div className="contact-step">
                                    <div className="contact-step-num">1</div>

                                    <div className="contact-step-text">
                                        <h4>Submit Your Information</h4>

                                        <p>
                                            Fill out the form above with details about your injury and situation.
                                        </p>
                                    </div>
                                </div>

                                <div className="contact-step">
                                    <div className="contact-step-num">2</div>

                                    <div className="contact-step-text">
                                        <h4>Attorney Review</h4>

                                        <p>
                                            Natlie G. Figgers' team reviews your submission promptly and
                                            confidentially.
                                        </p>
                                    </div>
                                </div>

                                <div className="contact-step">
                                    <div className="contact-step-num">3</div>

                                    <div className="contact-step-text">
                                        <h4>Free Consultation</h4>

                                        <p>
                                            A team member contacts you to schedule your free, no-obligation case
                                            consultation.
                                        </p>
                                    </div>
                                </div>

                                <div className="contact-step">
                                    <div className="contact-step-num">4</div>

                                    <div className="contact-step-text">
                                        <h4>Your Case Begins</h4>

                                        <p>
                                            If we take your case, we get to work immediately — with no upfront fees
                                            required.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <aside className="contact-aside">
                            <div className="gold-divider"></div>

                            <h3>Prefer to speak directly?</h3>

                            <p>
                                Reach the Figgers Law team during business hours for a confidential
                                conversation about your case.
                            </p>

                            <div className="contact-item">
                                <div className="contact-item-icon">
                                    <svg
                                        width="20"
                                        height="20"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        viewBox="0 0 24 24"
                                    >
                                        <path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384" />
                                    </svg>
                                </div>

                                <div>
                                    <div className="contact-item-label">Call</div>
                                    <div className="contact-item-val"><a href='mailto:8556435291'>(855) 643-5291</a></div>
                                </div>
                            </div>


                            <div className="contact-item">
                                <div className="contact-item-icon">
                                    <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
                                        <path d="M7 3h8l3 3v4" />
                                        <rect x="3" y="9" width="18" height="8" rx="2" />
                                        <path d="M7 17v4h10v-4" />
                                        <path d="M8 13h2" />
                                        <path d="M12 13h4" />
                                    </svg>
                                </div>

                                <div>
                                    <div className="contact-item-label">FAX</div>
                                    <div className="contact-item-val">(954) 369-1771</div>
                                </div>
                            </div>

                            <div className="contact-item">
                                <div className="contact-item-icon">
                                    <svg
                                        width="20"
                                        height="20"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        viewBox="0 0 24 24"
                                    >
                                        <path d="m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7" />
                                        <rect
                                            x="2"
                                            y="4"
                                            width="20"
                                            height="16"
                                            rx="2"
                                        />
                                    </svg>
                                </div>

                                <div>
                                    <div className="contact-item-label">Email</div>
                                    <div className="contact-item-val small">info@figgerslaw.com</div>
                                </div>
                            </div>

                            <div className="contact-item">
                                <div className="contact-item-icon">
                                    <svg
                                        width="20"
                                        height="20"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        viewBox="0 0 24 24"
                                    >
                                        <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0" />
                                        <circle
                                            cx="12"
                                            cy="10"
                                            r="3"
                                        />
                                    </svg>
                                </div>

                                <div>
                                    <div className="contact-item-label">Service Area</div>
                                    <div className="contact-item-val small">
                                        10100 West Sample Road,<br />
                                        Suite 300,<br />
                                        Coral Springs,<br />
                                        FL 33065 (By appointments only)
                                    </div>
                                </div>
                            </div>

                            <div className="contact-item">
                                <div className="contact-item-icon">
                                    <svg
                                        width="20"
                                        height="20"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth={2}
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                            cx="12"
                                            cy="12"
                                            r="10"
                                        />
                                        <path d="M12 6v6l4 2" />
                                    </svg>
                                </div>

                                <div>
                                    <div className="contact-item-label">Office Hours</div>
                                    <div className="contact-item-val small">
                                        Mon–Fri: 9AM – 6PM EST
                                    </div>
                                </div>
                            </div>

                            <div className="contact-aside-img-placeholder">
                                <span>Figgers Law Office</span>
                            </div>
                            {/* 
                            <div
                                style={{
                                    marginTop: "24px",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "10px",
                                }}
                            >
                                <Link
                                    to="/quick-assessment"
                                    className="btn-gold"
                                    style={{ justifyContent: "center" }}
                                >
                                    Take Quick Assessment
                                </Link>

                                <Link
                                    to="/calculator"
                                    className="btn-outline-ivory"
                                    style={{ justifyContent: "center" }}
                                >
                                    Settlement Calculator
                                </Link>
                            </div> */}
                        </aside>
                    </div>
                </div>
            </div>
            {resultDialog ?
                <SuccessErrorDialog type={type} message={message} open={resultDialog} handleClose={() => setResultDialog(false)} /> : null
            }
            <Footer></Footer>
        </>
    );
};

export default Contact;